/**
 * ShipShop Contract ABI (UUPS Upgradeable)
 * Auto-generated from compiled Solidity output.
 */
export const ShipShopAbi = [
	{
		"type": "constructor",
		"inputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "buyShip",
		"inputs": [
			{
				"name": "tier",
				"type": "uint8",
				"internalType": "enum ShipTier"
			}
		],
		"outputs": [
			{
				"name": "tokenId",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "cancelOwnershipHandover",
		"inputs": [],
		"outputs": [],
		"stateMutability": "payable"
	},
	{
		"type": "function",
		"name": "completeOwnershipHandover",
		"inputs": [
			{
				"name": "pendingOwner",
				"type": "address",
				"internalType": "address"
			}
		],
		"outputs": [],
		"stateMutability": "payable"
	},
	{
		"type": "function",
		"name": "initialize",
		"inputs": [
			{
				"name": "owner_",
				"type": "address",
				"internalType": "address"
			},
			{
				"name": "shipNFT_",
				"type": "address",
				"internalType": "address"
			},
			{
				"name": "usdc_",
				"type": "address",
				"internalType": "address"
			},
			{
				"name": "treasury_",
				"type": "address",
				"internalType": "address"
			},
			{
				"name": "probePrice_",
				"type": "uint256",
				"internalType": "uint256"
			},
			{
				"name": "frigatePrice_",
				"type": "uint256",
				"internalType": "uint256"
			},
			{
				"name": "dreadnoughtPrice_",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"outputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "owner",
		"inputs": [],
		"outputs": [
			{
				"name": "result",
				"type": "address",
				"internalType": "address"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "ownershipHandoverExpiresAt",
		"inputs": [
			{
				"name": "pendingOwner",
				"type": "address",
				"internalType": "address"
			}
		],
		"outputs": [
			{
				"name": "result",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "proxiableUUID",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "bytes32",
				"internalType": "bytes32"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "renounceOwnership",
		"inputs": [],
		"outputs": [],
		"stateMutability": "payable"
	},
	{
		"type": "function",
		"name": "requestOwnershipHandover",
		"inputs": [],
		"outputs": [],
		"stateMutability": "payable"
	},
	{
		"type": "function",
		"name": "setTierPrice",
		"inputs": [
			{
				"name": "tier",
				"type": "uint8",
				"internalType": "enum ShipTier"
			},
			{
				"name": "price",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"outputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "setTreasury",
		"inputs": [
			{
				"name": "treasury_",
				"type": "address",
				"internalType": "address"
			}
		],
		"outputs": [],
		"stateMutability": "nonpayable"
	},
	{
		"type": "function",
		"name": "shipNFT",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "address",
				"internalType": "contract IShipNFT"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "tierPrice",
		"inputs": [
			{
				"name": "",
				"type": "uint8",
				"internalType": "enum ShipTier"
			}
		],
		"outputs": [
			{
				"name": "",
				"type": "uint256",
				"internalType": "uint256"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "transferOwnership",
		"inputs": [
			{
				"name": "newOwner",
				"type": "address",
				"internalType": "address"
			}
		],
		"outputs": [],
		"stateMutability": "payable"
	},
	{
		"type": "function",
		"name": "treasury",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "address",
				"internalType": "address"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "function",
		"name": "upgradeToAndCall",
		"inputs": [
			{
				"name": "newImplementation",
				"type": "address",
				"internalType": "address"
			},
			{
				"name": "data",
				"type": "bytes",
				"internalType": "bytes"
			}
		],
		"outputs": [],
		"stateMutability": "payable"
	},
	{
		"type": "function",
		"name": "usdc",
		"inputs": [],
		"outputs": [
			{
				"name": "",
				"type": "address",
				"internalType": "contract IERC20"
			}
		],
		"stateMutability": "view"
	},
	{
		"type": "event",
		"name": "Initialized",
		"inputs": [
			{
				"name": "version",
				"type": "uint64",
				"indexed": false,
				"internalType": "uint64"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "OwnershipHandoverCanceled",
		"inputs": [
			{
				"name": "pendingOwner",
				"type": "address",
				"indexed": true,
				"internalType": "address"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "OwnershipHandoverRequested",
		"inputs": [
			{
				"name": "pendingOwner",
				"type": "address",
				"indexed": true,
				"internalType": "address"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "OwnershipTransferred",
		"inputs": [
			{
				"name": "oldOwner",
				"type": "address",
				"indexed": true,
				"internalType": "address"
			},
			{
				"name": "newOwner",
				"type": "address",
				"indexed": true,
				"internalType": "address"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "ShipPurchased",
		"inputs": [
			{
				"name": "buyer",
				"type": "address",
				"indexed": true,
				"internalType": "address"
			},
			{
				"name": "tokenId",
				"type": "uint256",
				"indexed": true,
				"internalType": "uint256"
			},
			{
				"name": "tier",
				"type": "uint8",
				"indexed": false,
				"internalType": "enum ShipTier"
			},
			{
				"name": "price",
				"type": "uint256",
				"indexed": false,
				"internalType": "uint256"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "TierPriceSet",
		"inputs": [
			{
				"name": "tier",
				"type": "uint8",
				"indexed": true,
				"internalType": "enum ShipTier"
			},
			{
				"name": "price",
				"type": "uint256",
				"indexed": false,
				"internalType": "uint256"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "TreasurySet",
		"inputs": [
			{
				"name": "treasury",
				"type": "address",
				"indexed": false,
				"internalType": "address"
			}
		],
		"anonymous": false
	},
	{
		"type": "event",
		"name": "Upgraded",
		"inputs": [
			{
				"name": "implementation",
				"type": "address",
				"indexed": true,
				"internalType": "address"
			}
		],
		"anonymous": false
	},
	{
		"type": "error",
		"name": "AlreadyInitialized",
		"inputs": []
	},
	{
		"type": "error",
		"name": "InvalidInitialization",
		"inputs": []
	},
	{
		"type": "error",
		"name": "NewOwnerIsZeroAddress",
		"inputs": []
	},
	{
		"type": "error",
		"name": "NoHandoverRequest",
		"inputs": []
	},
	{
		"type": "error",
		"name": "NotInitializing",
		"inputs": []
	},
	{
		"type": "error",
		"name": "SafeERC20FailedOperation",
		"inputs": [
			{
				"name": "token",
				"type": "address",
				"internalType": "address"
			}
		]
	},
	{
		"type": "error",
		"name": "TierNotForSale",
		"inputs": []
	},
	{
		"type": "error",
		"name": "TreasuryNotSet",
		"inputs": []
	},
	{
		"type": "error",
		"name": "Unauthorized",
		"inputs": []
	},
	{
		"type": "error",
		"name": "UnauthorizedCallContext",
		"inputs": []
	},
	{
		"type": "error",
		"name": "UpgradeFailed",
		"inputs": []
	}
] as const;

export type ShipShopAbiType = typeof ShipShopAbi;
